export default ['ar', 'he'];
